// extracted by css-extract-rspack-plugin
export default {"root":"root-ja9aJ4","disableScrollbar":"disableScrollbar-cmRDW3","content":"content-WE9Vq8"};